import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  globalClusterMetrics: [],
  metricsOfClusters: [],
  metricsOfCustomerClusters: [],
  clusterCount: [],
  clusterCountByCustomer: {},
  totalObjectCount: {},
  objectCountByCustomer: {},
  jobRuns: [],
  jobRunsByCustomer: [],
  countOfJobStatuses: [],
  countOfJobStatusesByCustomer: [],
  recentFailedJobs: [],
  recentFailedJobsByCustomer: [],
  countOfSLACompliance: [],
  countOfSLAComplianceByCustomer: [],
  storageOverviewOfClusters: [],
  storageOverviewByCustomer: [],
  error: null,
};

const mbDashboardSlice = createSlice({
  name: 'mbDashboard',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setGlobalClusterMetrics: (state, action) => {
      state.globalClusterMetrics = action.payload;
      state.error = null;
    },
    setMetricsOfClusters: (state, action) => {
      state.metricsOfClusters = action.payload;
      state.error = null;
    },
    setMetricsOfCustomerClusters: (state, action) => {
      state.metricsOfCustomerClusters = action.payload;
      state.error = null;
    },
    setTotalObjectCount: (state, action) => {
      state.totalObjectCount = action.payload;
      state.error = null;
    },
    setObjectCountByCustomer: (state, action) => {
      state.objectCountByCustomer = action.payload;
      state.error = null;
    },
    setClusterCount: (state, action) => {
      state.clusterCount = action.payload;
      state.error = null;
    },
    setClusterCountByCustomer: (state, action) => {
      state.clusterCountByCustomer = action.payload;
      state.error = null;
    },
    setJobRuns: (state, action) => {
      state.jobRuns = action.payload;
      state.error = null;
    },
    setJobRunsByCustomer: (state, action) => {
      state.jobRunsByCustomer = action.payload;
      state.error = null;
    },
    setCountOfJobStatuses: (state, action) => {
      state.countOfJobStatuses = action.payload;
      state.error = null;
    },
    setCountOfJobStatusesByCustomer: (state, action) => {
      state.countOfJobStatusesByCustomer = action.payload;
      state.error = null;
    },
    setRecentFailedJobs: (state, action) => {
      state.recentFailedJobs = action.payload;
      state.error = null;
    },
    setRecentFailedJobsByCustomer: (state, action) => {
      state.recentFailedJobsByCustomer = action.payload;
      state.error = null;
    },
    setCountOfSLACompliance: (state, action) => {
      state.countOfSLACompliance = action.payload;
      state.error = null;
    },
    setCountOfSLAComplianceByCustomer: (state, action) => {
      state.countOfSLAComplianceByCustomer = action.payload;
      state.error = null;
    },
    setStorageOverviewOfClusters: (state, action) => {
      state.storageOverviewOfClusters = action.payload;
      state.error = null;
    },
    setStorageOverviewByCustomer: (state, action) => {
      state.storageOverviewByCustomer = action.payload;
      state.error = null;
    },
    setResetMbDashboard: () => {
      return initialState;
    },
  },
});

// Export actions and reducer
export const {
  setReducerError,
  setGlobalClusterMetrics,
  setMetricsOfClusters,
  setMetricsOfCustomerClusters,
  setTotalObjectCount,
  setObjectCountByCustomer,
  setClusterCount,
  setClusterCountByCustomer,
  setJobRuns,
  setJobRunsByCustomer,
  setCountOfJobStatuses,
  setCountOfJobStatusesByCustomer,
  setRecentFailedJobs,
  setRecentFailedJobsByCustomer,
  setCountOfSLACompliance,
  setCountOfSLAComplianceByCustomer,
  setStorageOverviewOfClusters,
  setStorageOverviewByCustomer,
  setResetMbDashboard,
} = mbDashboardSlice.actions;

export default mbDashboardSlice.reducer;
